module.exports = __webpack_public_path__ + "static/img/wangLG.112a089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wangLG.png
// module id = 211
// module chunks = 1